/**
 * Madò Quick Add — bottone cerchio verde su product card
 * - Se il prodotto ha varianti multiple: redirect a PDP
 * - Altrimenti: add to cart via AJAX + feedback visivo
 */
(function () {
  'use strict';

  function init() {
    document.body.addEventListener('click', function (e) {
      var btn = e.target.closest('.mado-card-quick-add');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      handleAdd(btn);
    });
  }

  function handleAdd(btn) {
    if (btn.dataset.state === 'loading') return;

    // Se ha varianti, manda alla PDP (impossibile add senza scegliere)
    if (btn.dataset.hasVariants === 'true') {
      window.location.href = btn.dataset.productUrl;
      return;
    }

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.dataset.state = 'loading';
    btn.setAttribute('aria-busy', 'true');

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        btn.dataset.state = 'success';
        btn.setAttribute('aria-busy', 'false');
        // Trigger cart drawer/header count update se il tema lo ascolta
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        // Reset stato dopo 1.5s
        setTimeout(function () {
          if (btn.dataset.state === 'success') btn.dataset.state = '';
        }, 1500);
      })
      .catch(function () {
        btn.dataset.state = '';
        btn.setAttribute('aria-busy', 'false');
        // Fallback: porta in PDP
        window.location.href = btn.dataset.productUrl;
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
